import { findApplicant, findChildren } from '@hc-frontend/business'
import { Gender } from '@hc-frontend/entities'

function getApplicant(hcData) {
  const primary = Object.assign({}, findApplicant(hcData.members))
  const members = hcData.childOnly
    ? [findApplicant(hcData.members), ...findChildren(hcData.members)].filter(Boolean)
    : hcData.members
  const additional = members.length > 1 ? members.length - 1 : 0
  return {
    ...primary,
    gender: primary.gender === Gender.Male ? 'Male' : 'Female',
    additional
  }
}

export default getApplicant
